import { render, staticRenderFns } from "./RegisteredAddress.vue?vue&type=template&id=0172b810&scoped=true"
import script from "./RegisteredAddress.vue?vue&type=script&lang=js"
export * from "./RegisteredAddress.vue?vue&type=script&lang=js"
import style0 from "./RegisteredAddress.vue?vue&type=style&index=0&id=0172b810&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0172b810",
  null
  
)

export default component.exports